import { SlidersOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Modal, Row, Tooltip } from 'antd';
import { useTheme } from '../../providers/theme';
import { useState, useMemo } from 'react';
import { ChartSettingsProps } from '../../@types/data/types';
import { getColors } from '../utils/getColors';


const ChartSettings = ({ chartSettings, setChartSettings, autoDefaults }) => {
  const { isDay } = useTheme();
  const colors = getColors(isDay);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const data: ChartSettingsProps = {
      xmin: Number(values.xmin),
      xmax: Number(values.xmax),
      ymin: Number(values.ymin),
      ymax: Number(values.ymax)
    };
    setChartSettings(data);
    setIsModalOpen(false);
  };

  const isModified = useMemo(() => {
    return (
      chartSettings.xmin !== autoDefaults.xmin ||
      chartSettings.xmax !== autoDefaults.xmax ||
      chartSettings.ymin !== autoDefaults.ymin ||
      chartSettings.ymax !== autoDefaults.ymax
    );
  }, [chartSettings, autoDefaults]);

  const handleReset = () => {
    form.setFieldsValue(autoDefaults);
    setChartSettings(autoDefaults);
  };

  return (
    <>
      <Tooltip title="Chart Settings">
        <Button
          type="default"
          style={{ color: colors.text }}
          icon={<SlidersOutlined />}
          onClick={() => setIsModalOpen(true)}
          data-testid="chart-settings"
        />
      </Tooltip>

      <Modal
        title="Chart Settings"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="reset" onClick={handleReset} disabled={!isModified}>
            Reset
          </Button>,
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={form.submit}>
            Edit Chart
          </Button>
        ]}
      >
        <Form form={form} onFinish={onFinish}>
          <div style={{ marginTop: '2rem' }}>
            <h6>Limits</h6>
            <Row gutter={16} justify="space-between">
              <Col span={6} />
              <Col span={9}><p>Min</p></Col>
              <Col span={9}><p>Max</p></Col>
            </Row>
            <Row gutter={16}>
              <Col span={6}><p>X Axis</p></Col>
              <Col span={9}>
                <Form.Item name="xmin" initialValue={chartSettings.xmin}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item name="xmax" initialValue={chartSettings.xmax}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6}><p>Y Axis</p></Col>
              <Col span={9}>
                <Form.Item name="ymin" initialValue={chartSettings.ymin}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item name="ymax" initialValue={chartSettings.ymax}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ChartSettings;